/**
 * Ruoli assegnabili dentro un tenant, gli stessi ammessi dal database.
 * `barman` sta in cassa al bar: vede il bar e nient'altro.
 * `student` e' l'allievo del corso: vede l'app come un cliente.
 */
export const TENANT_ROLES = [
  'admin',
  'operator',
  'customer',
  'pilot',
  'instructor',
  'skydiver',
  'barman',
  'student',
] as const;

export type TenantRole = (typeof TENANT_ROLES)[number];
